import { merge } from 'lodash'
import { bank, TYPES as BANK_TYPES } from './bank/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      bank: {
        namespaced: true,
        modules: {
          bank
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    BANK_TYPES
  )

export { store, TYPES }
